import { setComponentClasses } from '../../../services/cosmosMkt/elementsCards'

export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    customClass: {
      type: Array,
      required: false,
    },
    header: {
      type: Boolean,
      required: false,
      default: true,
    },
    body: {
      type: Boolean,
      required: false,
      default: true,
    },
    footer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      getClasses: {},
    }
  },

  mounted() {
    this.getClasses = setComponentClasses(this.config)
  },
}
